import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
const styles = {
    loaderRoot: (theme) => ({
        color: theme.palette.secondary.main,
        padding: theme.spacing(0, 0.65),
    }),
};
export default function CustomLoader({ loaderSx = '', loaderAttributes = {
    size: 20,
    thickness: 3.6,
}, ...other }) {
    return (React.createElement(CircularProgress, { sx: loaderSx || styles.loaderRoot, size: loaderAttributes.size, thickness: loaderAttributes.thickness, ...other }));
}
